import _ from 'lodash'

const chat = (state) => _.get(state, 'chat')
const isMessageSending = (state) => _.get(state, 'status')
const messages = (state) => _.get(state, 'messages')
const messagesTotal = (state) => _.get(state, 'messagesTotal')

const chats = (state) => _.get(state, 'chats')
const isChatsLoading = (state) => _.get(state, 'chatListLoading')
const chatsTotal = (state) => _.get(state, 'chatsTotal')
const chatViolations = (state) => _.get(state, 'chatViolations')

const isMessagesLoading = (state) => _.get(state, 'messagesLoading')
const isMoreMessagesLoading = (state) => _.get(state, 'messageMoreLoading')
const currentChat = (state) => _.get(state, 'chat')

export default {
	chat,
	messages,
	chats,
	isMessageSending,
	isChatsLoading,
	isMessagesLoading,
	chatsTotal,
	messagesTotal,
	currentChat,
	chatViolations,
	isMoreMessagesLoading,
}
